import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
    customTextField: {
        "& input": {
            marginTop: '-3px',
            fontSize: '12px'
        },
        "& input::placeholder": {
            fontSize: "12px",
            fontStyle: 'italic'
        }
    }
})